import type { Action as MaterialAction } from "./material";

import { ActionType as MaterialActionType } from "./material";

export const ActionType = {
    ...MaterialActionType
}

export type Action = MaterialAction;